module.exports = __webpack_public_path__ + "static/img/kefu@2x.e297542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/issue/kefu@2x.png
// module id = AFxL
// module chunks = 18